import useSWR from 'swr';
import { buscarProntuarioPorId } from '../services/prontuario';

export default function useProntuario(id) {
  return useSWR(id ? ['prontuario', id] : null, () => buscarProntuarioPorId(id));
}
